// eslint-disable-next-line no-restricted-imports
import {
  SaveOnboardingDto_Input,
  MutationInput_ClientController_SaveOnboarding_Input_CurrentStepName as StepNameApi,
} from 'api/generated/graphql';
import { OnboardingProcessStepNameType } from 'api/types/entity';

const stepMap: Record<OnboardingProcessStepNameType, StepNameApi> = {
  [OnboardingProcessStepNameType.ClientAddresses]: StepNameApi.ClientAddresses,
  [OnboardingProcessStepNameType.ClientBankAccounts]:
    StepNameApi.ClientBankAccounts,
  [OnboardingProcessStepNameType.ClientBiography]: StepNameApi.ClientBiography,
  [OnboardingProcessStepNameType.ClientCitizenships]:
    StepNameApi.ClientCitizenships,
  [OnboardingProcessStepNameType.ClientConfirmDataAccuracy]:
    StepNameApi.ClientConfirmDataAccuracy,
  [OnboardingProcessStepNameType.ClientDebts]: StepNameApi.ClientDebts,
  [OnboardingProcessStepNameType.ClientFinancingSources]:
    StepNameApi.ClientFinancingSources,
  [OnboardingProcessStepNameType.ClientKyc]: StepNameApi.ClientKyc,
  [OnboardingProcessStepNameType.ClientOrderSubmissionContacts]:
    StepNameApi.ClientOrderSubmissionContacts,
  [OnboardingProcessStepNameType.ClientPep]: StepNameApi.ClientPep,
  [OnboardingProcessStepNameType.ClientSignatureCards]:
    StepNameApi.ClientSignatureCards,
  [OnboardingProcessStepNameType.ClientTaxResidencies]:
    StepNameApi.ClientTaxResidencies,
  [OnboardingProcessStepNameType.ClientSigningDocuments]:
    StepNameApi.ClientSigningDocuments,
  [OnboardingProcessStepNameType.ClientSigningQuestionnaire]:
    StepNameApi.ClientSigningQuestionnaire,
  [OnboardingProcessStepNameType.ClientSigningContract]:
    StepNameApi.ClientSigningServiceContract,
  [OnboardingProcessStepNameType.ClientBusinessRelationship]:
    StepNameApi.ClientBusinessRelationship,
  [OnboardingProcessStepNameType.ClientWithdrawalAccounts]:
    StepNameApi.ClientWithdrawalAccounts,
  [OnboardingProcessStepNameType.ClientRiskProfile]:
    StepNameApi.ClientRiskProfile,
  [OnboardingProcessStepNameType.ClientFinancialPosition]:
    StepNameApi.ClientFinancialPosition,
  [OnboardingProcessStepNameType.ClientW8BENForm]: StepNameApi.ClientW8BenForm,
  [OnboardingProcessStepNameType.ClientSourcesOfIncome]:
    StepNameApi.ClientIncomeSource,
  [OnboardingProcessStepNameType.ClientKnowledgeAndExperience]:
    StepNameApi.ClientKnowledgeAndExperience,
  [OnboardingProcessStepNameType.ClientInvoice]: StepNameApi.ClientInvoice,
  [OnboardingProcessStepNameType.ClientInvoicePaymentConfirmationFiles]:
    StepNameApi.ClientInvoicePaymentConfirmationFiles,
  [OnboardingProcessStepNameType.ClientRepresentativeAddresses]:
    StepNameApi.ClientRepresentativeAddresses,
  [OnboardingProcessStepNameType.ClientRepresentativeBankAccounts]:
    StepNameApi.ClientRepresentativeBankAccounts,
  [OnboardingProcessStepNameType.ClientRepresentativeBiography]:
    StepNameApi.ClientRepresentativeBiography,
  [OnboardingProcessStepNameType.ClientRepresentativeCitizenships]:
    StepNameApi.ClientRepresentativeCitizenships,
  [OnboardingProcessStepNameType.ClientRepresentativeCreateClient]:
    StepNameApi.ClientRepresentativeCreateClient,
  [OnboardingProcessStepNameType.ClientRepresentativeDebts]:
    StepNameApi.ClientRepresentativeDebts,
  [OnboardingProcessStepNameType.ClientRepresentativeKyc]:
    StepNameApi.ClientRepresentativeKyc,
  [OnboardingProcessStepNameType.ClientRepresentativePep]:
    StepNameApi.ClientRepresentativePep,
  [OnboardingProcessStepNameType.ClientRepresentativeBasisForRepresentation]:
    StepNameApi.ClientRepresentativeBasisForRepresentation,
  [OnboardingProcessStepNameType.ClientRepresentativeTaxResidencies]:
    StepNameApi.ClientRepresentativeTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryAddresses]:
    StepNameApi.LegalClientBeneficiaryAddresses,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryCitizenships]:
    StepNameApi.LegalClientBeneficiaryCitizenships,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryControlOverLegalClient]:
    StepNameApi.LegalClientBeneficiaryControlOverLegalClient,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryPep]:
    StepNameApi.LegalClientBeneficiaryPep,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryPersonalData]:
    StepNameApi.LegalClientBeneficiaryPersonalData,
  [OnboardingProcessStepNameType.LegalClientBeneficiaryTaxResidencies]:
    StepNameApi.LegalClientBeneficiaryTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientBranchAddresses]:
    StepNameApi.LegalClientBranchAddresses,
  [OnboardingProcessStepNameType.LegalClientBranchContacts]:
    StepNameApi.LegalClientBranchContacts,
  [OnboardingProcessStepNameType.LegalClientBranchName]:
    StepNameApi.LegalClientBranchName,
  [OnboardingProcessStepNameType.LegalClientBranchStateRegistration]:
    StepNameApi.LegalClientBranchStateRegistration,
  [OnboardingProcessStepNameType.LegalClientBranchTaxResidencies]:
    StepNameApi.LegalClientBranchTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientHeadAddresses]:
    StepNameApi.LegalClientHeadAddresses,
  [OnboardingProcessStepNameType.LegalClientHeadCitizenships]:
    StepNameApi.LegalClientHeadCitizenships,
  [OnboardingProcessStepNameType.LegalClientHeadPep]:
    StepNameApi.LegalClientHeadPep,
  [OnboardingProcessStepNameType.LegalClientHeadPersonalData]:
    StepNameApi.LegalClientHeadPersonalData,
  [OnboardingProcessStepNameType.LegalClientHeadTaxResidencies]:
    StepNameApi.LegalClientHeadTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientHeadPosition]:
    StepNameApi.LegalClientHeadPosition,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadAddresses]:
    StepNameApi.LegalClientLegalHeadFirstHeadAddresses,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadCitizenships]:
    StepNameApi.LegalClientLegalHeadFirstHeadCitizenships,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPep]:
    StepNameApi.LegalClientLegalHeadFirstHeadPep,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPersonalData]:
    StepNameApi.LegalClientLegalHeadFirstHeadPersonalData,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadPositionInCompany]:
    StepNameApi.LegalClientLegalHeadFirstHeadPositionInCompany,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadTaxResidencies]:
    StepNameApi.LegalClientLegalHeadFirstHeadTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeadIdentityDocument]:
    StepNameApi.LegalClientLegalHeadFirstHeadIdentityDocument,
  [OnboardingProcessStepNameType.LegalClientLegalHeadAddresses]:
    StepNameApi.LegalClientLegalHeadAddresses,
  [OnboardingProcessStepNameType.LegalClientLegalHeadCompanyName]:
    StepNameApi.LegalClientLegalHeadCompanyName,
  [OnboardingProcessStepNameType.LegalClientLegalHeadFirstHeads]:
    StepNameApi.LegalClientLegalHeadFirstHeads,
  [OnboardingProcessStepNameType.LegalClientLegalHeadStateRegistration]:
    StepNameApi.LegalClientLegalHeadStateRegistration,
  [OnboardingProcessStepNameType.LegalClientLegalHeadTaxResidencies]:
    StepNameApi.LegalClientLegalHeadTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientLegalHeadPosition]:
    StepNameApi.LegalClientLegalHeadPosition,
  [OnboardingProcessStepNameType.LegalClientLegalHeadOrganizationalAndLegalForm]:
    StepNameApi.LegalClientLegalHeadOrganizationalAndLegalForm,
  [OnboardingProcessStepNameType.LegalClientRepresentativeAddresses]:
    StepNameApi.LegalClientRepresentativeAddresses,
  [OnboardingProcessStepNameType.LegalClientRepresentativeBiography]:
    StepNameApi.LegalClientRepresentativeBiography,
  [OnboardingProcessStepNameType.LegalClientRepresentativeCitizenships]:
    StepNameApi.LegalClientRepresentativeCitizenships,
  [OnboardingProcessStepNameType.LegalClientRepresentativeCompanyAddresses]:
    StepNameApi.LegalClientRepresentativeCompanyAddresses,
  [OnboardingProcessStepNameType.LegalClientRepresentativeCompanyConstitutionalDocument]:
    StepNameApi.LegalClientRepresentativeCompanyConstitutionalDocument,
  [OnboardingProcessStepNameType.LegalClientRepresentativeCompanyName]:
    StepNameApi.LegalClientRepresentativeCompanyName,
  [OnboardingProcessStepNameType.LegalClientRepresentativeCompanyStateRegistration]:
    StepNameApi.LegalClientRepresentativeCompanyStateRegistration,
  [OnboardingProcessStepNameType.LegalClientRepresentativeCompanyTaxResidencies]:
    StepNameApi.LegalClientRepresentativeCompanyTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientRepresentativeKyc]:
    StepNameApi.LegalClientRepresentativeKyc,
  [OnboardingProcessStepNameType.LegalClientRepresentativePep]:
    StepNameApi.LegalClientRepresentativePep,
  [OnboardingProcessStepNameType.LegalClientRepresentativeRoleInCompany]:
    StepNameApi.LegalClientRepresentativeRoleInCompany,
  [OnboardingProcessStepNameType.LegalClientRepresentativeTaxResidencies]:
    StepNameApi.LegalClientRepresentativeTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientActivityTypes]:
    StepNameApi.LegalClientActivityTypes,
  [OnboardingProcessStepNameType.LegalClientAddresses]:
    StepNameApi.LegalClientAddresses,
  [OnboardingProcessStepNameType.LegalClientBankAccounts]:
    StepNameApi.LegalClientBankAccounts,
  [OnboardingProcessStepNameType.LegalClientBeneficiaries]:
    StepNameApi.LegalClientBeneficiaries,
  [OnboardingProcessStepNameType.LegalClientBodies]:
    StepNameApi.LegalClientBodies,
  [OnboardingProcessStepNameType.LegalClientBranches]:
    StepNameApi.LegalClientBranches,
  [OnboardingProcessStepNameType.LegalClientBusinessRelationship]:
    StepNameApi.LegalClientBusinessRelationship,
  [OnboardingProcessStepNameType.LegalClientConfirmDataAccuracy]:
    StepNameApi.LegalClientConfirmDataAccuracy,
  [OnboardingProcessStepNameType.LegalClientConstitutionalDocument]:
    StepNameApi.LegalClientConstitutionalDocument,
  [OnboardingProcessStepNameType.LegalClientContacts]:
    StepNameApi.LegalClientContacts,
  [OnboardingProcessStepNameType.LegalClientDebts]:
    StepNameApi.LegalClientDebts,
  [OnboardingProcessStepNameType.LegalClientFinancialMonitoring]:
    StepNameApi.LegalClientFinancialMonitoring,
  [OnboardingProcessStepNameType.LegalClientFinancingSources]:
    StepNameApi.LegalClientFinancingSources,
  [OnboardingProcessStepNameType.LegalClientHeads]:
    StepNameApi.LegalClientHeads,
  [OnboardingProcessStepNameType.LegalClientInvoice]:
    StepNameApi.LegalClientInvoice,
  [OnboardingProcessStepNameType.LegalClientInvoicePaymentConfirmationFiles]:
    StepNameApi.LegalClientInvoicePaymentConfirmationFiles,
  [OnboardingProcessStepNameType.LegalClientLicenseInfo]:
    StepNameApi.LegalClientLicenseInfo,
  [OnboardingProcessStepNameType.LegalClientOrderSubmissionContacts]:
    StepNameApi.LegalClientOrderSubmissionContacts,
  [OnboardingProcessStepNameType.LegalClientOrganizationalAndLegalForm]:
    StepNameApi.LegalClientOrganizationalAndLegalForm,
  [OnboardingProcessStepNameType.LegalClientOwnershipStructure]:
    StepNameApi.LegalClientOwnershipStructure,
  [OnboardingProcessStepNameType.LegalClientRegistrationPlace]:
    StepNameApi.LegalClientRegistrationPlace,
  [OnboardingProcessStepNameType.LegalClientSignatureCards]:
    StepNameApi.LegalClientSignatureCards,
  [OnboardingProcessStepNameType.LegalClientStateRegistration]:
    StepNameApi.LegalClientStateRegistration,
  [OnboardingProcessStepNameType.LegalClientTaxResidencies]:
    StepNameApi.LegalClientTaxResidencies,
  [OnboardingProcessStepNameType.LegalClientWithdrawalAccounts]:
    StepNameApi.LegalClientWithdrawalAccounts,
  [OnboardingProcessStepNameType.LegalClientCompanyName]:
    StepNameApi.LegalClientCompanyName,
  [OnboardingProcessStepNameType.LegalClientSigningQuestionnaire]:
    StepNameApi.LegalClientSigningQuestionnaire,
  [OnboardingProcessStepNameType.LegalClientIdentificationNumbers]:
    StepNameApi.LegalClientIdentificationNumbers,
  [OnboardingProcessStepNameType.LegalClientActivity]:
    StepNameApi.LegalClientActivity,
  [OnboardingProcessStepNameType.LegalClientKnowledgeAndExperience]:
    StepNameApi.LegalClientKnowledgeAndExperience,
  [OnboardingProcessStepNameType.LegalClientTargetedFinancialInstruments]:
    StepNameApi.LegalClientTargetedFinancialInstruments,
  [OnboardingProcessStepNameType.LegalClientInvestmentPurposeAndNature]:
    StepNameApi.LegalClientInvestmentPurposeAndNature,
  [OnboardingProcessStepNameType.LegalClientSourcesOfIncome]:
    StepNameApi.LegalClientIncomeSources,
  [OnboardingProcessStepNameType.LegalClientW8BenForm]:
    StepNameApi.LegalClientW8BenForm,
  [OnboardingProcessStepNameType.LegalClientFinancialMonitoringPartOne]:
    StepNameApi.LegalClientFinancialMonitoringPartOne,
  [OnboardingProcessStepNameType.LegalClientFinancialMonitoringPartTwo]:
    StepNameApi.LegalClientFinancialMonitoringPartTwo,
  [OnboardingProcessStepNameType.LegalClientSigningServiceContract_Global]:
    StepNameApi.LegalClientSigningServiceContractGlobal,
  [OnboardingProcessStepNameType.LegalClientSigningDocuments_Finance]:
    StepNameApi.LegalClientSigningDocumentsFinance,
};

export const parseOnboardingSettingsSaveParam = (
  currentStepName: OnboardingProcessStepNameType
): SaveOnboardingDto_Input => ({ currentStepName: stepMap[currentStepName] });
